import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS, getData, postData } from '../../constants/api';
import PatientDetail from './PatientInfo';
import PatientTabs from './PatientTabs';
import { updateColumn } from '../../constants/functions';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { CURRENT_DATE } from '../../constants';
import { Link } from 'react-router-dom';

function AppointmentsList({ appointments, title, onSelect }) {
  console.log('appointments:', appointments);
  const getBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'scheduled':
        return 'bg-warning text-dark'; // warning badge with dark text for contrast
      case 'process':
        return 'bg-info text-dark';
      case 'canceled':
        return 'bg-danger';
      case 'completed':
        return 'bg-success';
      default:
        return 'bg-secondary';
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">{title}</h4>
      </div>
      <ul className="list-group">
        {appointments &&
          appointments.length > 0 &&
          appointments.map((appt) => (
            <li
              key={appt.ID}
              className="list-group-item"
              onClick={() => onSelect(appt)}
              style={{ cursor: 'pointer' }}
            >
              <div className="fw-bold">
                {appt.Patient}{' '}
                <span className={`badge ${getBadgeClass(appt.Status)}`}>
                  {appt.Status}
                </span>
                {appt.Type === 'out' && appt.Status === 'scheduled' && (
                  <>
                    &nbsp; &nbsp; &nbsp;
                    <button
                      className={`btn btn-danger btn-sm`}
                      onClick={(e) =>
                        updateColumn(
                          e,
                          `updatecolumn/caafi_appointment/${appt.ID}/status/process`,
                          'Enter'
                        )
                      }
                    >
                      Call
                    </button>
                  </>
                )}
                &nbsp;&nbsp;{' '}
                <Link
                  to={`/activity-report/full-patient-history?patient_id=${appt.PatientID}`}
                >
                  History
                </Link>
              </div>
              <div className="text-muted">
                Age: <strong>{appt.Age}</strong> — Date:{' '}
                <strong>{appt['Appointment Date']}</strong> -Type:{' '}
                <strong>{appt.Type}</strong>
              </div>
              {appt.Type === 'in' && (
                <div className="fw-bold">
                  {appt?.Doctor} - {appt?.Room}
                </div>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
}

export default function DoctorPortal() {
  const [appointments, setAppointments] = useState([]);
  const [inPatients, setInPatients] = useState([]);

  const [date, setDate] = useState(CURRENT_DATE);
  const [status, setStatus] = useState('scheduled');

  const [date2, setDate2] = useState('0000-00-00');
  const [status2, setStatus2] = useState('scheduled');

  const token = getToken();
  const user_id = decodeToken(token, 'id');
  useEffect(() => {
    const fetchAppointments = async () => {
      const body = {
        user_id: user_id,
        date: date,
        status: status,
        type: 'out',
      };
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/doctor-appointments`;
      try {
        const appointmentsResult = await postData(url, body);
        // console.log('appointmentsResult:', appointmentsResult);
        setAppointments(appointmentsResult.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAppointments();
  }, [date, status]);

  useEffect(() => {
    const fetchInPatients = async () => {
      const body = {
        user_id: user_id,
        date: date2,
        status: status2,
        type: 'in',
      };
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/doctor-in-patients`;
      try {
        const appointmentsResult = await postData(url, body);
        // console.log('appointmentsResult:', appointmentsResult);
        setInPatients(appointmentsResult.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchInPatients();
  }, [date2.status]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [patientType, setPatientType] = useState(null);
  const [room, setRoom] = useState(null);

  const handleSelect = (appointment) => {
    console.log('app:', appointment);
    setSelectedAppointment(appointment.ID);

    setPatientType(appointment.Type);
    setRoom(appointment.Room);
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-3">
          <div className="row g-3">
            {/* Date input */}
            <div className="col">
              <label htmlFor="date" className="form-label">
                Select Date
              </label>
              <input
                type="date"
                id="date"
                className="form-control"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            {/* Status */}
            <div className="col">
              <label htmlFor="dropdown2" className="form-label">
                Select Status
              </label>
              <select
                id="dropdown2"
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="%">-- Select --</option>
                <option value="scheduled">scheduled</option>
                <option value="process">process</option>
                <option value="completed">completed</option>
                <option value="cancelled">cancelled</option>
              </select>
            </div>
            {/* type */}
          </div>
          <AppointmentsList
            appointments={appointments}
            title="My Appointments"
            // onSelect={setSelectedAppointment}
            onSelect={handleSelect}
          />

          <div className="row g-3">
            <br />
            <hr />
            <br />

            {/* Date input */}
            <div className="col">
              <label htmlFor="date" className="form-label">
                Select Date
              </label>
              <input
                type="date"
                id="date"
                className="form-control"
                value={date2}
                onChange={(e) => setDate2(e.target.value)}
              />
            </div>
            {/* Status */}
            <div className="col">
              <label htmlFor="dropdown2" className="form-label">
                Select Status
              </label>
              <select
                id="dropdown2"
                className="form-select"
                value={status2}
                onChange={(e) => setStatus2(e.target.value)}
              >
                <option value="%">-- Select --</option>
                <option value="scheduled">scheduled</option>
                <option value="process">process</option>
                <option value="completed">completed</option>
                <option value="cancelled">cancelled</option>
              </select>
            </div>
            {/* type */}
          </div>

          <AppointmentsList
            appointments={inPatients}
            title="In Patients"
            onSelect={handleSelect}
          />
        </div>
        <div className="col-9">
          <PatientTabs
            appointmentId={selectedAppointment}
            patientType={patientType}
            room={room}
          />
        </div>
      </div>
    </div>
  );
}
